module.exports = __webpack_public_path__ + "static/media/fly0155.bc6bbb9f.webp";